import { LazyLoad } from '@petconsole/pure-fe-mui';

const PetType = LazyLoad(() => import('./PetTypeApp'));
const PetTypes = LazyLoad(() => import('./PetTypes'));

export { PetType, PetTypes };
